import React from 'react'
import { connect } from 'react-redux'
import Col from 'muicss/lib/react/col'
import Activity from './Activity'
import { loadPeopleLog } from '../../../actions'
import MedalDialog from '../MedalDialog'
import MissionDialog from '../MissionDialog'
import TitleDialog from '../TitleDialog'
import { selectActivityMedal, selectActivityMission, selectActivityTitle } from '../../../actions'

const styles = {
  empty:{
    textAlign: 'center',
    minHeight: '300px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  }
}

const toggleDialog = (activity,toggleOpen,dispatch) => {
    if (activity.mission) {
      dispatch(selectActivityMission({mission: activity.mission}))
    }else if(activity.medal){
      dispatch(selectActivityMedal({medal: activity.medal}))
    }else if(activity.title){
      dispatch(selectActivityTitle({title: activity.title}))
    }
    toggleOpen(activity)
  }


class Activities extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      medalOpen: false,
      missionOpen: false,
      titleOpen: false,
    }
  }

  toggleOpen = (activity) => {
    if (activity.mission) {
      this.missionToggleOpen()
    }else if(activity.medal){
      this.medalToggleOpen()
    }else if(activity.title){
      this.titleToggleOpen()
    }
  }

  missionToggleOpen = () => {
    this.setState({
      missionOpen: !this.state.missionOpen,
    })
  }
  
  titleToggleOpen = () => {
    this.setState({
      titleOpen: !this.state.titleOpen,
    })
  }

  medalToggleOpen = () => {
    this.setState({
      medalOpen: !this.state.medalOpen,
    })
  }


  componentDidMount = () =>
    this.props.loadPeopleLog()

  render = () => (
    this.props.activities.length>0 ? 
      <div>
        { this.props.activities.map(activity => Activity(activity,this.toggleOpen,this.props.toggleDialog)) }
        <MedalDialog toggleOpen={this.medalToggleOpen} open={this.state.medalOpen} />
        <MissionDialog toggleOpen={this.missionToggleOpen} open={this.state.missionOpen} />
        <TitleDialog toggleOpen={this.titleToggleOpen} open={this.state.titleOpen} />
      </div> : 
      <Col xs="12" style={styles.empty}><h1>¡No hay actividad para mostrar!</h1></Col>
    
  )
}



const mapStateToProps = state => ({
  activities: state.user.people_log,
})

const mapDispatchToProps = dispatch => ({
  loadPeopleLog: () => dispatch(loadPeopleLog()),
  toggleDialog: (activity,toggleOpen) => toggleDialog(activity,toggleOpen,dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(Activities)



// WEBPACK FOOTER //
// ./src/components/Main/Activities/index.jsx